import logo from './logo.svg';
import './App.css';
import NameDisplay from './NameDisplay';
import { ConfigProvider } from 'antd';

function App() {
  return (
    <ConfigProvider theme={{
      token: {
        colorPrimary: 'black',
      }}
    }>
    <div>
      <NameDisplay />
    </div>
    </ConfigProvider>
  );
}

export default App;
